// extracted by mini-css-extract-plugin
export default {"meal":"MealsItem_meal__iIQKT","description":"MealsItem_description__q2YrE","price":"MealsItem_price__Sb1Uw"};